<script setup lang="ts">
import { XModal } from '@clicksign/excalibur';

import { BrandButton } from '~~base-ui';

export type DigitalCertificateMobileWarningModalEmit = {
  (event: 'close'): void;
};

const emit = defineEmits<DigitalCertificateMobileWarningModalEmit>();

function close() {
  emit('close');
}
</script>

<template>
  <XModal
    role="dialog"
    :is-open="true"
    :close-button="false"
    width="332"
    data-testid="mobileWarningModal"
    @close="close()"
  >
    <template #default>
      <p>
        {{ $t(`requirement.digitalCertificate.local.modal.mobileWarning.description`) }}
      </p>
    </template>

    <template #actions>
      <BrandButton
        data-testid="modalCloseButton"
        @click="close()"
      >
        {{ $t('requirement.common.close') }}
      </BrandButton>
    </template>
  </XModal>
</template>
